import { Box } from '@mui/material';
import goldMarkIcon from '@assets/images/gold_mark_icon.png';
import { Offer } from '@modules/offers/types';

const RenderOfferOverlay = (typeKey: string, offer: Offer, amount: string) => {
  switch (typeKey) {
    case 'gold_mark':
      return (
        <Box
          sx={{
            position: 'absolute',
            height: '14px',
            top: '15px',
            left: 0,
            right: 0,
            textAlign: 'center',
            zIndex: 2,
            color: '#fffefc',
            letterSpacing: '1px',
            fontWeight: 700,
            textShadow: '1px 1px 6px rgba(0,0,0,0.75)',
            fontSize: '16px',
            pointerEvents: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: '22px', height: '22px', mr: '4px' }}>
            <img src={goldMarkIcon} alt="gold_mark_icon" />
          </Box>
          <span>{amount}</span>
        </Box>
      );
    case 'premium_account':
      return (
        <Box
          sx={{
            position: 'absolute',
            top: 18,
            left: 0,
            right: 0,
            textAlign: 'center',
            zIndex: 2,
            color: '#fff',
            fontWeight: 700,
            fontSize: '22px',
            textShadow: '1px 1px 8px rgba(0,0,0,0.6)',
            pointerEvents: 'none',
          }}
        >
          <div style={{ letterSpacing: '2px', fontSize: '16px' }}>7 DAYS</div>
          <div
            style={{
              fontSize: '14px',
              fontWeight: 400,
              width: 'calc(100% - 20px)',
              color: '#f8c475',
              letterSpacing: '1px',
            }}
          >
            Premium Account
          </div>
        </Box>
      );
    case 'hero_medals':
      return (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 2,
            fontWeight: 700,
            fontSize: '21px',
            textShadow: '1px 1px 8px rgba(0,0,0,0.60)',
            pointerEvents: 'none',
          }}
        >
          <div
            style={{
              fontSize: '19px',
              fontWeight: 700,
              height: '30px',
              marginBottom: '5px',
              textTransform: 'uppercase',
              backgroundColor: '#1f1610cc',
              color: '#fff',
              textAlign: 'center',
            }}
          >
            {offer.offer_name ?? 'ORHAN PROMOTION'}
          </div>
          <div
            style={{
              marginTop: '26px',
              padding: '2px 5px 2px 50px',
              background: 'linear-gradient(270deg, #1f1610cc, #1f1610b3 75%, #0000 100%)',
              maxWidth: '352px',
              float: 'right',
            }}
          >
            <div
              style={{ position: 'relative', fontSize: '19px', color: '#f8c475', textAlign: 'right', fontWeight: 700 }}
            >
              <span>{amount} HERO MEDALS</span>
            </div>
            {/* <div style={{ fontSize: '19px', color: '#f8c475', textAlign: 'right' }}>
              <span style={{ fontWeight: 700 }}>+6 BOOSTERS</span>
            </div> */}
          </div>
          {/* <HeroMedal /> */}
        </Box>
      );
    default:
      return null;
  }
};

export default RenderOfferOverlay;
